import { TO_action_YOU_HAVE_TO_BE_loggedIn, TO_BE_LOGGED_IN } from 'mk/autogenerated/translations/auth.adbacd40aecc2c6a4a0853bd2a2e3c12'
import { isAnonymous } from 'mk/bazaar/common/userUtils';
import { login_url } from 'mk/urls/functions';
import Interpolate from 'mk2/components/Interpolate';
import { showWarningToast } from 'mk2/helpers/toasts';
import { getRequestUser } from 'mk2/reducers';
import { getRoutingLocation } from 'mk2/selectors';
import * as React from 'react';
import { select } from 'redux-saga/effects';

export function* checkIfUserIsLoggedIn(action: string) {
    const requestUser = yield select(getRequestUser);
    if (isAnonymous(requestUser)) {
        const location = yield select(getRoutingLocation);
        yield showWarningToast(
            <Interpolate
                i18nKey={TO_action_YOU_HAVE_TO_BE_loggedIn}
                action={action}
                loggedIn={<a href={login_url({ next: location.pathname })}>{TO_BE_LOGGED_IN}</a>}
            />,
        );
        return false;
    }
    return true;
}
